import React, {createContext, useContext, useMemo, useState} from 'react';

interface LicenseSettingsContextProps {
    totalValue: number;
    updateTotalValue: (value: number) => void;
    trialStatus?: boolean;
    visible: boolean;
    forceUpdate: () => void;
    toggleVisible: (value: boolean) => void;
}

interface LicenseSettingsProviderProps {
    children: React.ReactNode;
    usedValue: number; 
    isTrial: boolean;
    fetchLicenses: () => void;
}

const LicenseSettingsContext = createContext<LicenseSettingsContextProps | undefined>(undefined);

export const LicenseSettingsProvider: React.FC<LicenseSettingsProviderProps> = ({ children, usedValue, isTrial, fetchLicenses }) => {
    const [totalValue, setTotalValue] = useState<number>(usedValue);
    const trialStatus = isTrial;
    const forceUpdate = fetchLicenses;
    const [visible, setVisible] = useState<boolean>(false);


    const updateTotalValue = (value: number) => {
        setTotalValue(Number(totalValue) + value);
    };

    const toggleVisible = (value: boolean) => {
        setVisible(value);
    };

    const value = useMemo(
        () => ({
          totalValue,
          updateTotalValue,
          trialStatus,
          forceUpdate,
          visible,
          toggleVisible
        }),
        [totalValue, trialStatus, forceUpdate, visible]
      );

    return (
        <LicenseSettingsContext.Provider value={value}>
            {children}
        </LicenseSettingsContext.Provider>
    );
};

export const useLicenseSettings = () => {
    const context = useContext(LicenseSettingsContext);
    if (context === undefined) {
        throw new Error('useLicenseSettings must be used within a LicenseSettingsProvider');
    }
    return context;
};